import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="mb-8 md:mb-10">
          <span className="text-xs font-semibold text-primary-500 uppercase tracking-wider">💬 REVIEWS</span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mt-2">读者好评</h2>
          <p className="text-sm text-foreground-500 mt-1">来自真实漫友的使用体验，听听他们怎么说</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {commentsData.map((item, idx) => (
            <div key={idx} className="bg-background-100 rounded-2xl p-6 flex flex-col">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center text-primary-600 font-bold text-sm flex-shrink-0">
                  {item.avatar}
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-foreground-900">{item.name}</h3>
                  <span className="text-xs text-foreground-400">{item.date}</span>
                </div>
              </div>
              <div className="flex items-center gap-1 mb-3">
                {[1, 2, 3, 4, 5].map((star) => (
                  <i key={star} className="ri-star-fill text-xs text-secondary-500"></i>
                ))}
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed flex-1">{item.text}</p>
              <div className="flex items-center gap-3 mt-4 pt-4 border-t border-background-200/70">
                <span className="text-xs text-foreground-400 flex items-center gap-1 cursor-pointer">
                  <i className="ri-thumb-up-line"></i>{item.likes}
                </span>
                <span className="text-xs text-foreground-400 cursor-pointer">
                  <i className="ri-chat-1-line"></i> 回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}